// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.line-view .ready {\n\tborder-bottom-right-radius: 0.5rem;\n\tborder-bottom-left-radius: 0.5rem;\n}\n.portrait-thumb-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n.portrait-preview {\n\twidth: 100% !important;\n\theight: 100% !important;\n\t-o-object-fit: contain;\n\t   object-fit: contain;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
